module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh":{"searchPlaceholder":"游戏名称/APPID","gameAdd":"添加游戏","gameManage":"游戏管理","empty":"您还没有游戏，请先添加游戏"},"en":{"searchPlaceholder":"Game Name / APPID","gameAdd":"Game Add","gameManage":"Game Manage","empty":"No game, Please add game first"}}')
  delete Component.options._Ctor
}
